import { FlaskConical } from "lucide-react";

export function DemoBadge({ className = "" }) {
  return (
    <span
      data-testid="demo-badge"
      title="Operazione dimostrativa (dati fittizi)"
      className={`inline-flex items-center gap-1 text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-sm border border-[#EA7B2B]/40 text-[#EA7B2B] bg-[#EA7B2B]/10 ${className}`}
    >
      <FlaskConical className="w-2.5 h-2.5" /> Demo
    </span>
  );
}
